/** Data local atual no formato esperado por inputs HTML (`YYYY-MM-DD`). */
export function currentLocalDateInput(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function currentDatePeriod(): { startDate: string; endDate: string } {
  const currentDate = currentLocalDateInput();
  return { startDate: currentDate, endDate: currentDate };
}
